const BANK_CODE_JAPAN_POST_BANK = '9900'

export const MajorBanks = [
  { bank_code: '5', bank_name: '三菱ＵＦＪ銀行' },
  { bank_code: '1', bank_name: 'みずほ銀行' },
  { bank_code: '10', bank_name: 'りそな銀行' },
  { bank_code: '17', bank_name: '埼玉りそな銀行' },
  { bank_code: '9', bank_name: '三井住友銀行' },
  { bank_code: '33', bank_name: 'ＰａｙＰａｙ銀行' },
  { bank_code: '36', bank_name: '楽天銀行' },
  { bank_code: BANK_CODE_JAPAN_POST_BANK, bank_name: 'ゆうちょ銀行' },
]

export const BankNameInitialGroups = [
  {
    name: 'あ',
    initials: [
      { body: 'あ', value: 'ｱ' },
      { body: 'い', value: 'ｲ' },
      { body: 'う', value: 'ｳ' },
      { body: 'え', value: 'ｴ' },
      { body: 'お', value: 'ｵ' },
    ],
  },
  {
    name: 'か',
    initials: [
      { body: 'か', value: 'ｶ' },
      { body: 'き', value: 'ｷ' },
      { body: 'く', value: 'ｸ' },
      { body: 'け', value: 'ｹ' },
      { body: 'こ', value: 'ｺ' },
    ],
  },
  {
    name: 'さ',
    initials: [
      { body: 'さ', value: 'ｻ' },
      { body: 'し', value: 'ｼ' },
      { body: 'す', value: 'ｽ' },
      { body: 'せ', value: 'ｾ' },
      { body: 'そ', value: 'ｿ' },
    ],
  },
  {
    name: 'た',
    initials: [
      { body: 'た', value: 'ﾀ' },
      { body: 'ち', value: 'ﾁ' },
      { body: 'つ', value: 'ﾂ' },
      { body: 'て', value: 'ﾃ' },
      { body: 'と', value: 'ﾄ' },
    ],
  },
  {
    name: 'な',
    initials: [
      { body: 'な', value: 'ﾅ' },
      { body: 'に', value: 'ﾆ' },
      { body: 'ぬ', value: 'ﾇ' },
      { body: 'ね', value: 'ﾈ' },
      { body: 'の', value: 'ﾉ' },
    ],
  },
  {
    name: 'は',
    initials: [
      { body: 'は', value: 'ﾊ' },
      { body: 'ひ', value: 'ﾋ' },
      { body: 'ふ', value: 'ﾌ' },
      { body: 'へ', value: 'ﾍ' },
      { body: 'ほ', value: 'ﾎ' },
    ],
  },
  {
    name: 'ま',
    initials: [
      { body: 'ま', value: 'ﾏ' },
      { body: 'み', value: 'ﾐ' },
      { body: 'む', value: 'ﾑ' },
      { body: 'め', value: 'ﾒ' },
      { body: 'も', value: 'ﾓ' },
    ],
  },
  {
    name: 'や',
    initials: [
      { body: 'や', value: 'ﾔ' },
      { body: 'ゆ', value: 'ﾕ' },
      { body: 'よ', value: 'ﾖ' },
    ],
  },
  {
    name: 'ら',
    initials: [
      { body: 'ら', value: 'ﾗ' },
      { body: 'り', value: 'ﾘ' },
      { body: 'る', value: 'ﾙ' },
      { body: 'れ', value: 'ﾚ' },
      { body: 'ろ', value: 'ﾛ' },
    ],
  },
  {
    name: 'わ',
    initials: [
      { body: 'わ', value: 'ﾜ' },
      { body: 'を', value: 'ｦ' },
      { body: 'ん', value: 'ﾝ' },
    ],
  },
]

export const BankAccountTypes = [
  { name: '普通', value: '1' },
  { name: '当座', value: '2' },
  { name: '貯蓄', value: '4' },
]

export const bankAccountTypeForValue = (value: string | number) =>
  BankAccountTypes.find((type) => type.value == String(value))

export const isBankCodeForJapanPostBank = (bankCode: string | number) =>
  BANK_CODE_JAPAN_POST_BANK == bankCode
